import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerYoutubeAnalyticsSponsoredPosts.graphql';
import { Query, QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs } from '../../__generated__/globalTypes';

export const useInfluencerYoutubeAnalyticsSponsoredPostsQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerYoutubeAnalyticsSponsoredPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs>
): QueryResult<Query, QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs> & {
  getInfluencerYoutubeAnalyticsSponsoredPosts: LazyQueryExecFunction<
    Query,
    QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerYoutubeAnalyticsSponsoredPosts, result] = useLazyQuery<
    Query,
    QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerYoutubeAnalyticsSponsoredPosts, ...result };
};

export const useInfluencerYoutubeAnalyticsSponsoredPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerYoutubeAnalyticsSponsoredPosts = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerYoutubeAnalyticsSponsoredPosts };
};
// Suspense Query Hooks
export const useInfluencerYoutubeAnalyticsSponsoredPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerYoutubeAnalyticsSponsoredPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
